import { ApiDataAccess, Dictionary, ReadonlyHttpApiListRepository } from '@softline/core';
import { SupplierPrice } from '@softapps/wws/core';
import { inject, Injectable } from '@angular/core';
import { SOFTLINE_API_WWS_ARTIKELSTAMM_PRODUCT_SUPPLIER_PRICES } from '../artikelstamm.api';
import { SupplierPriceQuery } from '../types/supplier-price.query';

@Injectable()
export class SupplierPriceRepository extends ReadonlyHttpApiListRepository<SupplierPrice[], SupplierPriceQuery> {

  constructor() {
    super(inject(ApiDataAccess), SOFTLINE_API_WWS_ARTIKELSTAMM_PRODUCT_SUPPLIER_PRICES);
  }

  protected override getLoadPathParams(params: SupplierPriceQuery): Dictionary<unknown> | undefined {
    console.log('SupplierPriceRepository: ', {
      id: params.productId,
      supplierId: params.supplierId
    })
    return {
      id: params.productId,
      supplierId: params.supplierId
    };
  }

  protected override getLoadQueryParams(params: SupplierPriceQuery): Dictionary<unknown> | undefined {
    return {
      showAll: params.all
    };
  }

  async getPricesOfSupplier(productId: number | string, supplierId: number | string): Promise<SupplierPrice[]> {
    return await this.dataAccess.get(
      {
        path: SOFTLINE_API_WWS_ARTIKELSTAMM_PRODUCT_SUPPLIER_PRICES,
        pathParams: {id: productId, supplierId: supplierId}
      }
    )
  }
}
